module.exports = __webpack_public_path__ + "img/type_2.2f58e934.jpg";